// MultiPathRoute.jsx
import React from 'react';
import PropTypes from 'prop-types';
import { useLocation, matchPath, Routes, Route } from 'react-router';
import { EMPTY_ARRAY } from '../resource/defaults.js';

export const MultiPathRoute = ({ paths = EMPTY_ARRAY, element }) => {
  const location = useLocation();

  if (!paths.length) return null;

  const matchedPath = paths.find(path => matchPath(path, location.pathname));
  if (!matchedPath) return null;

  return (
    <Routes>
      <Route path={matchedPath} element={element} />
    </Routes>
  );
};

MultiPathRoute.propTypes = {
  paths: PropTypes.array.isRequired,
  element: PropTypes.element.isRequired,
};

export default MultiPathRoute;
